import React, { Component } from 'react';
import styled, { keyframes } from 'styled-components';

import avatar1 from '../../images/feature-graphics/avatars/avatar1.jpg';
import avatar2 from '../../images/feature-graphics/avatars/avatar2.jpg';
import avatar3 from '../../images/feature-graphics/avatars/avatar3.jpg';
import avatar4 from '../../images/feature-graphics/avatars/avatar4.jpg';

const avatars = [avatar1, avatar2, avatar3, avatar4];

const Wrapper = styled.div`
  position: relative;
`;

const details = [
  {
    email: 'delaney1988@gmail.com',
    address: '2998 Polk Street',
    phone: '(323)654-64472',
  },
  {
    email: 'reie.ankundi@hotmail.co',
    address: '3595 Cantebury Dr',
    phone: '(206)940-1011',
  },
  {
    email: 'junior1973@hotmail.com',
    address: '1531 Cecil Street',
    phone: '(817)299-08714',
  },
  {
    email: 'evalyn.schimm@yahoo.com',
    address: '1397 Bee Street',
    phone: '(631)468-31343',
  },
];

const Table = styled.div`
  background: #ffffff;
  max-width: 500px;
  width: 100%;
  position: relative;
  z-index: 10;
`;

const Avatar = styled.div`
  background: url(${props => avatars[props.person || 0]}) center no-repeat;
  background-size: cover;
  border-radius: 50%;
  display: block;
  margin-right: 1em;
  width: 3em;
  height: 3em;
`;

const Row = styled.div`
  background: ${props => (props.alt ? 'rgb(248, 250, 255)' : '#fff')};
  transform: ${props => (props.active ? 'scale(1.08)' : 'none')};
  box-shadow: ${props =>
    props.active
      ? '0 19px 45px rgba(137, 149, 199, 0.15),0 0px 19px rgba(137, 149, 199, 0.08);'
      : 'none'};
  opacity: ${props => (props.active ? '1' : '0.65')};
  z-index: ${props => (props.active ? '4' : '1')};
  position: relative;
  transition: transform 0.75s, box-shadow 0.5s;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  overflow: hidden;
  align-items: center;
  font-size: 0.8em;
  padding: 1.3em 0.8em;
`;
const Col = styled.div`
  display: block;
  flex: ${props => props.grow} 1 10px;
  margin: 0 10px 0 0;

  @media (max-width: 500px) {
    display: ${props => (props.mobile === 'hide' ? 'none' : 'block')};
  }
`;

const ValueAnimation = keyframes`
  0% {
    width: 0%;
  }
  100% {
    width: 100%;
  }
`;

const Value = styled.div`
  animation: ${props => (props.active ? ValueAnimation : 'none')} 0.4s
    ${props => props.delay * 0.3}s ease-in 1;
  animation-fill-mode: backwards;
  // background: #fffde3;
  padding: 3px 0;
  font-size: 13px;
  border-radius: 2px;
  transition: width 0.5s;
  overflow: hidden;
  text-overflow: clip;
  overflow: hidden;
  white-space: nowrap;
  width: ${props => (props.persist ? '100%' : props.active ? 'auto' : '0%')};
`;

const Tick = styled.div`
  background: #57e34a;
  opacity: ${props => (props.done ? '1' : '0')};
  border-radius: 50%;
  width: 1.5em;
  height: 1.5em;
  transition: ${props =>
    props.done ? 'opacity .4s 1.1s, margin .6s 1.1s ease-out' : 'none'};
  margin-top: ${props => (props.done ? '0' : '-2em')};
  position: relative;
  font-weight: 700;
  float: right;

  &:after {
    content: ' ';
    border-bottom: solid 3px #fff;
    border-right: solid 3px #fff;
    border-radius: 0 0 2px 0;
    width: 4px;
    height: 9px;
    position: absolute;
    transform: rotate(45deg);
    top: 0.17em;
    left: 0.45em;
  }
`;

const timeout = 2400;

class CollectionGraphic extends Component {
  constructor(props) {
    super(props);
    this.state = {
      active: 2,
      children: 3,
    };
  }

  tick = () => {
    let active = this.state.active;
    let max = this.state.children;
    this.setState(
      {
        active: active < max ? active + 1 : 0,
      },
      () => {
        window.setTimeout(this.tick, timeout);
      }
    );
  };

  componentDidMount() {
    window.setTimeout(this.tick, timeout);
  }

  render() {
    return (
      <Wrapper>
        <Table>
          {[1, 2, 3, 4].map((el, id) => {
            let active = id === this.state.active;
            let persist = id < this.state.active;
            return (
              <Row key={id} active={active} alt={id % 2}>
                <Col grow={1}>
                  <Avatar person={id} typing={active} />
                </Col>
                <Col grow={2} mobile="hide">
                  <Value type="email" active={active} delay={1} persist={persist}>
                    {details[id].email}
                  </Value>
                </Col>
                <Col grow={2} mobile="hide">
                  <Value type="phone" active={active} delay={2} persist={persist}>
                    {details[id].phone}
                  </Value>
                </Col>
                <Col grow={4}>
                  <Value type="address" active={active} delay={3} persist={persist}>
                    {details[id].address}
                  </Value>
                </Col>
                <Col grow={1}>
                  <Tick done={active || persist} />
                </Col>
              </Row>
            );
          })}
        </Table>
      </Wrapper>
    );
  }
}

export default CollectionGraphic;
